import Vue from 'vue';
const state = {
	msg: '',
	type: '',
	status: ''
};

const mutations = {

};

const actions = {
	info({ state, commit }, { msg }) {
		Vue.prototype.$notify({
			title: 'Información',
			message: msg,
			position: 'top-right',
			offset: 100,
			type: 'info'
		});
	},
	ok({ state, commit }, { msg }) {
		Vue.prototype.$notify({
			title: 'Éxito',
			message: msg,
			position: 'top-right',
			offset: 100,
			type: 'success'
		});
	},
	warning({ state, commit }, { msg }) {
		Vue.prototype.$notify({
			title: 'Atención',
			message: msg,
			position: 'top-right',
			offset: 100,
			type: 'warning'
		});
	},
	error({ state, commit }, { msg }) {
		Vue.prototype.$notify({
			title: 'Error',
			message: msg,
			position: 'top-right',
			offset: 100,
			type: 'error'
		});
	},
	custom({ state, commit }, { msg,title, icon, position, type, duration }) {
		Vue.prototype.$notify({
			title: title ? title : 'Notificación',
			message: msg,
			position: position ? position : 'top-right',
			iconClass: icon ? icon: null,
			offset: 100,
			type: type ? type : null,
			duration: duration !== null || duration !==undefined ? duration : '4500'
		});
	},

};

const getters = {

};

export default {
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
